import clsx from 'clsx'
import { ComponentProps } from 'react'

export function InlineFieldGroup({ className, ...props }: ComponentProps<'div'>) {
  return <div {...props} data-slot="control" className={clsx(className, 'mt-3 space-y-3')} />
}

export function InlineField({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) {
  return (
    <div
      className={clsx(
        className,
        '[&>[data-slot=label]+[data-slot=control]]:mt-0.5',
        '[&>[data-slot=label]+input[type=hidden]+[data-slot=control]]:mt-0.5', // headlessui inserts hidden input for Listbox
        '[&>[data-slot=label]+[data-slot=description]]:mt-px',
        '[&>[data-slot=description]+[data-slot=control]]:mt-1.5',
        '[&>[data-slot=control]+[data-slot=description]]:mt-1.5',
        '[&>[data-slot=control]+[data-slot=error]]:mt-1.5',
        '[&>[data-slot=label]]:font-medium'
      )}
      {...props}
    />
  )
}

export function InlineLabel({ className, ...props }: ComponentProps<'label'>) {
  return (
    <label
      {...props}
      data-slot="label"
      className={clsx(className, 'select-none text-xs/6 text-zinc-500 disabled:opacity-50 dark:text-zinc-400')}
    />
  )
}
